import { HIGHLIGHTS } from "utils/ToolTipConst";
import PopText from "components/Wrappers/PopText";


export default function MapTutorial({
  onClose=() => null,
}:{
  onClose?: () => void,
}) {

  return (
    <div className="flex flex-col">
      <button className="absolute top-2 right-2" onClick={onClose}>x</button>
      <h1>Map Navigation Tutorial</h1>

      <p>The <PopText recordName="map" text="Map" recordType="generic" /> shows the state of the wetlands at the <span className={HIGHLIGHTS.neutral}>start of the year</span>.</p>
      <p>You can pan the map with <span className={HIGHLIGHTS.neutral}>right click</span>, or zoom in with <span className={HIGHLIGHTS.neutral}>the mouse wheel</span>. To recenter the map, click on the <span className={HIGHLIGHTS.neutral}>map recenter button</span>         <span className="text-xl relative ml-2">
          {" "}box 
        </span> in the top left of your screen.</p>
      <p>In order to affect the map, you can <span className={HIGHLIGHTS.neutral}>propose actions</span> using the action tools on the bottom of the screen. For information about these tools, you an click on the question mark above their icon. To see how your actions will affect the wetlands next year, click on the <span className={HIGHLIGHTS.neutral}>simulate button</span> on the bottom right.</p>
      <p>The action buttons will grant you the abilty to click on a map <PopText recordName="cell" text="cell" recordType="generic" /> or <PopText recordName="management unit" text="management unit" recordType="generic" /> in order to propose your action.</p>
      <p>Birds on the map, if visible, represent the final state after last year. The birds may end up in different locals/populations given a different selected <PopText recordName="water regime" text="water regime" recordType="generic" />  at <PopText recordName="townhall" text="townhall" recordType="generic" /></p>

    </div>
  )
}
